export default {
  label: {
    notes:
      'Label of action to start exciter expert analysis from visualisation',
    message: 'Exciter expert analysis',
  },
};
